import { render, staticRenderFns } from "./sellers.modal.vue?vue&type=template&id=829caaea&scoped=true&"
import script from "./sellers.modal.vue?vue&type=script&lang=js&"
export * from "./sellers.modal.vue?vue&type=script&lang=js&"
import style0 from "./sellers.modal.vue?vue&type=style&index=0&id=829caaea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829caaea",
  null
  
)

export default component.exports